import { useMemo } from 'react';
import React from 'react';
import { useQuery } from '@common-fe/common-fe';
import { Text } from '@common-fe/common-fe';
import _ from 'lodash';
import styled from 'styled-components';

import { api } from '@/api';
import { ValuesMap } from '@/common/types';
import { API_URL } from '@/dtos';
import { RoleModel } from '@/modules/contact/types/Contact.types';
import { IPermission, IPermissionGroup, RoleLevel } from '@/modules/role/role.types';

const StyledText = styled(Text)`
  text-transform: capitalize;
`;
export const PERMISSIONS_LIST_QUERY_KEY = 'permissionsList';
interface Params {
  isViewMode?: boolean;
  isClaimMode?: boolean;
  isUserMode?: boolean;
  disabled?: boolean;
}
interface RoleModelResponse extends RoleModel {
  level_type: RoleLevel;
}
interface Response {
  allowed_for_creation_by_user: RoleModelResponse[];
  allowed_for_organization: RoleModelResponse[];
}

// UPLOAD_CLAIM_DOCUMENT(51)
// CLAIM_TEAM (73);
// VIEW_CLAIM(44),
// PROCESS_CLAIM(15),
// CLAIM_TRANSFER(61),

const ALLOWED_ROLES = [15, 51, 44];
export const useRolesAllowedToCreationQuery = (params?: Params) => {
  const { data, isLoading } = useQuery(
    [PERMISSIONS_LIST_QUERY_KEY, params?.isClaimMode],
    () =>
      // TODO: the type is missing
      api.get<Response>(API_URL.ROLES_USER_AND_ORGANIZATION, {
        params: {
          ...(params?.isClaimMode
            ? {
                granted_permission_ids: ALLOWED_ROLES.join(', '),
              }
            : {}),
        },
      }),
    {
      enabled: !params?.disabled,
    }
  );
  const currentList = useMemo(() => {
    const list =
      (params?.isUserMode
        ? data?.data?.allowed_for_creation_by_user
        : data?.data?.allowed_for_organization) || [];
    return list;
  }, [data?.data?.allowed_for_creation_by_user, data?.data?.allowed_for_organization, params?.isUserMode]);
  const options = useMemo(() => {
    const list = currentList;
    return list.map((role) => ({
      id: role.id,
      key: `${role.id}`,
      label: (
        <StyledText weight={params?.isViewMode ? 'bold' : 'normal'}>
          {role.name.split('_').join(' ').toLowerCase()}
        </StyledText>
      ),
      title: role.name,
      value: `${role.id}`,
    }));
  }, [currentList, params?.isViewMode]);
  const groups: IPermissionGroup[] = useMemo(() => {
    const groupsMap: ValuesMap<IPermission[]> = {};
    currentList.forEach((item) => {
      const currentItem: IPermission = {
        ...item,
        name: item.name,
        description: '',
        key: `${item.id || ''}`,
        id: `${item.id || ''}`,
      };
      if (groupsMap[item.level_type]) {
        groupsMap[item.level_type] = [...groupsMap[item.level_type], currentItem];
      } else {
        groupsMap[item.level_type] = [currentItem];
      }
    });

    const keys = Object.keys(groupsMap);

    return keys.map((key) => ({
      id: key,
      name: _.capitalize(key),
      options: groupsMap[key],
    }));
  }, [currentList]);

  return {
    groups,
    options,
    isLoading,
  };
};
export default useRolesAllowedToCreationQuery;
